module.exports = __webpack_public_path__ + "website/img/computer_5.7d79b950.png";